import classes from "./Background.module.css";

export const Background = () => {
  return <div className={classes.Background} />;
};
